export const KwToPsMultiplier = 1.35962;
